import { useCallback } from 'react';

export function useClearQueryParams() {
  return useCallback((paramsToClear?: string[]) => {
    const url = new URL(window.location.href);

    if (Array.isArray(paramsToClear) && paramsToClear.length > 0) {
      paramsToClear.forEach((param) => url.searchParams.delete(param));
    } else {
      url.search = '';
    }
    window.history.replaceState({}, '', url);
  }, []);
}
